// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file asset/v1/asset.proto (package asset.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { Any, AnyJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file asset/v1/asset.proto.
 */
export const file_asset_v1_asset: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_any, file_google_protobuf_timestamp],
	);

/**
 * @generated from message asset.v1.Asset
 */
export type Asset = Message<"asset.v1.Asset"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 14;
	 */
	name: string;

	/**
	 * @generated from field: string description = 15;
	 */
	description: string;

	/**
	 * @generated from field: string path = 2;
	 */
	path: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;

	/**
	 * @generated from field: string owner_id = 16;
	 */
	ownerId: string;

	/**
	 * @generated from field: asset.v1.AssetType asset_type = 6;
	 */
	assetType: AssetType;

	/**
	 * @generated from field: asset.v1.AssetState state = 7;
	 */
	state: AssetState;

	/**
	 * @generated from field: string version = 22;
	 */
	version: string;

	/**
	 * @generated from field: bool latest_version = 24;
	 */
	latestVersion: boolean;

	/**
	 * @generated from field: asset.v1.CreationMethod creation_method = 8;
	 */
	creationMethod: CreationMethod;

	/**
	 * @generated from field: google.protobuf.Any data = 9;
	 */
	data?: Any | undefined;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp archived_at = 20;
	 */
	archivedAt?: Timestamp | undefined;

	/**
	 * @generated from field: string opaque_id = 17;
	 */
	opaqueId: string;

	/**
	 * @generated from field: asset.v1.Visibility visibility = 18;
	 */
	visibility: Visibility;

	/**
	 * @generated from field: asset.v1.ArchiveReason archive_reason = 19;
	 */
	archiveReason: ArchiveReason;

	/**
	 * @generated from field: string category = 21;
	 */
	category: string;

	/**
	 * @generated from field: string container_id = 23;
	 */
	containerId: string;
};

/**
 * @generated from message asset.v1.Asset
 */
export type AssetJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 14;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 15;
	 */
	description?: string;

	/**
	 * @generated from field: string path = 2;
	 */
	path?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string owner_id = 16;
	 */
	ownerId?: string;

	/**
	 * @generated from field: asset.v1.AssetType asset_type = 6;
	 */
	assetType?: AssetTypeJson;

	/**
	 * @generated from field: asset.v1.AssetState state = 7;
	 */
	state?: AssetStateJson;

	/**
	 * @generated from field: string version = 22;
	 */
	version?: string;

	/**
	 * @generated from field: bool latest_version = 24;
	 */
	latestVersion?: boolean;

	/**
	 * @generated from field: asset.v1.CreationMethod creation_method = 8;
	 */
	creationMethod?: CreationMethodJson;

	/**
	 * @generated from field: google.protobuf.Any data = 9;
	 */
	data?: AnyJson;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp archived_at = 20;
	 */
	archivedAt?: TimestampJson;

	/**
	 * @generated from field: string opaque_id = 17;
	 */
	opaqueId?: string;

	/**
	 * @generated from field: asset.v1.Visibility visibility = 18;
	 */
	visibility?: VisibilityJson;

	/**
	 * @generated from field: asset.v1.ArchiveReason archive_reason = 19;
	 */
	archiveReason?: ArchiveReasonJson;

	/**
	 * @generated from field: string category = 21;
	 */
	category?: string;

	/**
	 * @generated from field: string container_id = 23;
	 */
	containerId?: string;
};

/**
 * Describes the message asset.v1.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema: GenMessage<Asset, { jsonType: AssetJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 0);

/**
 * @generated from message asset.v1.DateRange
 */
export type DateRange = Message<"asset.v1.DateRange"> & {
	/**
	 * Optional timestamp in RFC3339 format
	 *
	 * @generated from field: string start_date = 1;
	 */
	startDate: string;

	/**
	 * optional timestamp in RFC3339 format
	 *
	 * @generated from field: string end_date = 2;
	 */
	endDate: string;
};

/**
 * @generated from message asset.v1.DateRange
 */
export type DateRangeJson = {
	/**
	 * Optional timestamp in RFC3339 format
	 *
	 * @generated from field: string start_date = 1;
	 */
	startDate?: string;

	/**
	 * optional timestamp in RFC3339 format
	 *
	 * @generated from field: string end_date = 2;
	 */
	endDate?: string;
};

/**
 * Describes the message asset.v1.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<DateRange, { jsonType: DateRangeJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 1);

/**
 * If multiple filters are provided, they are combined together with the AND condition
 *
 * @generated from message asset.v1.AssetFilter
 */
export type AssetFilter = Message<"asset.v1.AssetFilter"> & {
	/**
	 * returns assets only of the provides types
	 *
	 * @generated from field: repeated asset.v1.AssetType asset_types = 1;
	 */
	assetTypes: AssetType[];

	/**
	 * returns assets only in the provides states
	 *
	 * @generated from field: repeated asset.v1.AssetState states = 2;
	 */
	states: AssetState[];

	/**
	 * returns assets only in the provided creation method
	 *
	 * @generated from field: optional asset.v1.CreationMethod creation_method = 3;
	 */
	creationMethod?: CreationMethod | undefined;

	/**
	 * returns only assets by the creator
	 * Deprecated: Use creator_ids instead
	 *
	 * @generated from field: string creator_id = 4 [deprecated = true];
	 * @deprecated
	 */
	creatorId: string;

	/**
	 * returns assets that match the supplied name prefix
	 *
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * return assets that exactly match a string
	 *
	 * @generated from field: optional string exact_name = 16;
	 */
	exactName?: string | undefined;

	/**
	 * return assets that exactly match a list of strings
	 *
	 * @generated from field: repeated string exact_names = 17;
	 */
	exactNames: string[];

	/**
	 * returns assets associated with all of the supplied tags
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * CreatedAtDateRange scopes the response to assets created in the specified range. The filter is exclusive
	 *
	 * When start_date is empty the filtering will get everything created up to end_date
	 * When end_date is empty the filtering will get everything created from the start_date up until now
	 *
	 * @generated from field: optional asset.v1.DateRange created_at_date_range = 7;
	 */
	createdAtDateRange?: DateRange | undefined;

	/**
	 * returns only assets by the owner
	 *
	 * @generated from field: repeated string owner_ids = 8;
	 */
	ownerIds: string[];

	/**
	 * @generated from field: string opaque_id = 9;
	 */
	opaqueId: string;

	/**
	 * returns assets that match any of the supplied set of visibilities
	 *
	 * @generated from field: repeated asset.v1.Visibility visibilities = 11;
	 */
	visibilities: Visibility[];

	/**
	 * returns assets that match any of the supplied set of asset categories
	 *
	 * @generated from field: repeated string categories = 12;
	 */
	categories: string[];

	/**
	 * @generated from field: optional asset.v1.Location location = 13;
	 */
	location?: Location | undefined;

	/**
	 * returns assets that match any of the supplied set of creator ids
	 *
	 * @generated from field: repeated string creator_ids = 14;
	 */
	creatorIds: string[];

	/**
	 * @generated from field: optional string path = 15;
	 */
	path?: string | undefined;
};

/**
 * If multiple filters are provided, they are combined together with the AND condition
 *
 * @generated from message asset.v1.AssetFilter
 */
export type AssetFilterJson = {
	/**
	 * returns assets only of the provides types
	 *
	 * @generated from field: repeated asset.v1.AssetType asset_types = 1;
	 */
	assetTypes?: AssetTypeJson[];

	/**
	 * returns assets only in the provides states
	 *
	 * @generated from field: repeated asset.v1.AssetState states = 2;
	 */
	states?: AssetStateJson[];

	/**
	 * returns assets only in the provided creation method
	 *
	 * @generated from field: optional asset.v1.CreationMethod creation_method = 3;
	 */
	creationMethod?: CreationMethodJson;

	/**
	 * returns only assets by the creator
	 * Deprecated: Use creator_ids instead
	 *
	 * @generated from field: string creator_id = 4 [deprecated = true];
	 * @deprecated
	 */
	creatorId?: string;

	/**
	 * returns assets that match the supplied name prefix
	 *
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * return assets that exactly match a string
	 *
	 * @generated from field: optional string exact_name = 16;
	 */
	exactName?: string;

	/**
	 * return assets that exactly match a list of strings
	 *
	 * @generated from field: repeated string exact_names = 17;
	 */
	exactNames?: string[];

	/**
	 * returns assets associated with all of the supplied tags
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * CreatedAtDateRange scopes the response to assets created in the specified range. The filter is exclusive
	 *
	 * When start_date is empty the filtering will get everything created up to end_date
	 * When end_date is empty the filtering will get everything created from the start_date up until now
	 *
	 * @generated from field: optional asset.v1.DateRange created_at_date_range = 7;
	 */
	createdAtDateRange?: DateRangeJson;

	/**
	 * returns only assets by the owner
	 *
	 * @generated from field: repeated string owner_ids = 8;
	 */
	ownerIds?: string[];

	/**
	 * @generated from field: string opaque_id = 9;
	 */
	opaqueId?: string;

	/**
	 * returns assets that match any of the supplied set of visibilities
	 *
	 * @generated from field: repeated asset.v1.Visibility visibilities = 11;
	 */
	visibilities?: VisibilityJson[];

	/**
	 * returns assets that match any of the supplied set of asset categories
	 *
	 * @generated from field: repeated string categories = 12;
	 */
	categories?: string[];

	/**
	 * @generated from field: optional asset.v1.Location location = 13;
	 */
	location?: LocationJson;

	/**
	 * returns assets that match any of the supplied set of creator ids
	 *
	 * @generated from field: repeated string creator_ids = 14;
	 */
	creatorIds?: string[];

	/**
	 * @generated from field: optional string path = 15;
	 */
	path?: string;
};

/**
 * Describes the message asset.v1.AssetFilter.
 * Use `create(AssetFilterSchema)` to create a new message.
 */
export const AssetFilterSchema: GenMessage<AssetFilter, { jsonType: AssetFilterJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 2);

/**
 * @generated from message asset.v1.UpdateAssetRequest
 */
export type UpdateAssetRequest = Message<"asset.v1.UpdateAssetRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 10;
	 */
	version: string;

	/**
	 * @generated from field: optional string path = 2 [deprecated = true];
	 * @deprecated
	 */
	path?: string | undefined;

	/**
	 * optional tags needed as we migrate tagging into the assets-service
	 * updating an assets tag will hit the assets-service mutations after migrations
	 *
	 * @generated from field: repeated string tags = 3;
	 */
	tags: string[];

	/**
	 * optional data to store with this asset
	 *
	 * @generated from field: google.protobuf.Any data = 4;
	 */
	data?: Any | undefined;

	/**
	 * Name is an optional display name associated to the asset.
	 *
	 * @generated from field: optional string name = 5;
	 */
	name?: string | undefined;

	/**
	 * Description is an optional description associated to the asset.
	 *
	 * @generated from field: optional string description = 6;
	 */
	description?: string | undefined;

	/**
	 * OwnerId is an optional field used to "transfer ownership" of an asset
	 *
	 * @generated from field: optional string owner_id = 7;
	 */
	ownerId?: string | undefined;

	/**
	 * @generated from field: asset.v1.Visibility visibility = 8;
	 */
	visibility: Visibility;

	/**
	 * @generated from field: optional string category = 9;
	 */
	category?: string | undefined;
};

/**
 * @generated from message asset.v1.UpdateAssetRequest
 */
export type UpdateAssetRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 10;
	 */
	version?: string;

	/**
	 * @generated from field: optional string path = 2 [deprecated = true];
	 * @deprecated
	 */
	path?: string;

	/**
	 * optional tags needed as we migrate tagging into the assets-service
	 * updating an assets tag will hit the assets-service mutations after migrations
	 *
	 * @generated from field: repeated string tags = 3;
	 */
	tags?: string[];

	/**
	 * optional data to store with this asset
	 *
	 * @generated from field: google.protobuf.Any data = 4;
	 */
	data?: AnyJson;

	/**
	 * Name is an optional display name associated to the asset.
	 *
	 * @generated from field: optional string name = 5;
	 */
	name?: string;

	/**
	 * Description is an optional description associated to the asset.
	 *
	 * @generated from field: optional string description = 6;
	 */
	description?: string;

	/**
	 * OwnerId is an optional field used to "transfer ownership" of an asset
	 *
	 * @generated from field: optional string owner_id = 7;
	 */
	ownerId?: string;

	/**
	 * @generated from field: asset.v1.Visibility visibility = 8;
	 */
	visibility?: VisibilityJson;

	/**
	 * @generated from field: optional string category = 9;
	 */
	category?: string;
};

/**
 * Describes the message asset.v1.UpdateAssetRequest.
 * Use `create(UpdateAssetRequestSchema)` to create a new message.
 */
export const UpdateAssetRequestSchema: GenMessage<UpdateAssetRequest, { jsonType: UpdateAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 3);

/**
 * @generated from message asset.v1.UpdateAssetsRequest
 */
export type UpdateAssetsRequest = Message<"asset.v1.UpdateAssetsRequest"> & {
	/**
	 * @generated from field: repeated asset.v1.UpdateAssetRequest assets = 1;
	 */
	assets: UpdateAssetRequest[];
};

/**
 * @generated from message asset.v1.UpdateAssetsRequest
 */
export type UpdateAssetsRequestJson = {
	/**
	 * @generated from field: repeated asset.v1.UpdateAssetRequest assets = 1;
	 */
	assets?: UpdateAssetRequestJson[];
};

/**
 * Describes the message asset.v1.UpdateAssetsRequest.
 * Use `create(UpdateAssetsRequestSchema)` to create a new message.
 */
export const UpdateAssetsRequestSchema: GenMessage<UpdateAssetsRequest, { jsonType: UpdateAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 4);

/**
 * ArchiveAssetRequest updates the state of the asset to archived
 *
 * @generated from message asset.v1.ArchiveAssetsRequest
 */
export type ArchiveAssetsRequest = Message<"asset.v1.ArchiveAssetsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];

	/**
	 * @generated from field: optional asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason?: ArchiveReason | undefined;
};

/**
 * ArchiveAssetRequest updates the state of the asset to archived
 *
 * @generated from message asset.v1.ArchiveAssetsRequest
 */
export type ArchiveAssetsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];

	/**
	 * @generated from field: optional asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason?: ArchiveReasonJson;
};

/**
 * Describes the message asset.v1.ArchiveAssetsRequest.
 * Use `create(ArchiveAssetsRequestSchema)` to create a new message.
 */
export const ArchiveAssetsRequestSchema: GenMessage<ArchiveAssetsRequest, { jsonType: ArchiveAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 5);

/**
 * @generated from message asset.v1.ArchiveAssetRequest
 */
export type ArchiveAssetRequest = Message<"asset.v1.ArchiveAssetRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: optional asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason?: ArchiveReason | undefined;
};

/**
 * @generated from message asset.v1.ArchiveAssetRequest
 */
export type ArchiveAssetRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: optional asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason?: ArchiveReasonJson;
};

/**
 * Describes the message asset.v1.ArchiveAssetRequest.
 * Use `create(ArchiveAssetRequestSchema)` to create a new message.
 */
export const ArchiveAssetRequestSchema: GenMessage<ArchiveAssetRequest, { jsonType: ArchiveAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 6);

/**
 * @generated from message asset.v1.RestoreAssetRequest
 */
export type RestoreAssetRequest = Message<"asset.v1.RestoreAssetRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: optional asset.v1.AssetState state = 2;
	 */
	state?: AssetState | undefined;
};

/**
 * @generated from message asset.v1.RestoreAssetRequest
 */
export type RestoreAssetRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: optional asset.v1.AssetState state = 2;
	 */
	state?: AssetStateJson;
};

/**
 * Describes the message asset.v1.RestoreAssetRequest.
 * Use `create(RestoreAssetRequestSchema)` to create a new message.
 */
export const RestoreAssetRequestSchema: GenMessage<RestoreAssetRequest, { jsonType: RestoreAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 7);

/**
 * @generated from message asset.v1.RestoreAssetsRequest
 */
export type RestoreAssetsRequest = Message<"asset.v1.RestoreAssetsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];

	/**
	 * @generated from field: optional asset.v1.AssetState state = 2;
	 */
	state?: AssetState | undefined;
};

/**
 * @generated from message asset.v1.RestoreAssetsRequest
 */
export type RestoreAssetsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];

	/**
	 * @generated from field: optional asset.v1.AssetState state = 2;
	 */
	state?: AssetStateJson;
};

/**
 * Describes the message asset.v1.RestoreAssetsRequest.
 * Use `create(RestoreAssetsRequestSchema)` to create a new message.
 */
export const RestoreAssetsRequestSchema: GenMessage<RestoreAssetsRequest, { jsonType: RestoreAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 8);

/**
 * @generated from message asset.v1.DeleteAssetRequest
 */
export type DeleteAssetRequest = Message<"asset.v1.DeleteAssetRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message asset.v1.DeleteAssetRequest
 */
export type DeleteAssetRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message asset.v1.DeleteAssetRequest.
 * Use `create(DeleteAssetRequestSchema)` to create a new message.
 */
export const DeleteAssetRequestSchema: GenMessage<DeleteAssetRequest, { jsonType: DeleteAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 9);

/**
 * @generated from message asset.v1.DeleteAssetsRequest
 */
export type DeleteAssetsRequest = Message<"asset.v1.DeleteAssetsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message asset.v1.DeleteAssetsRequest
 */
export type DeleteAssetsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message asset.v1.DeleteAssetsRequest.
 * Use `create(DeleteAssetsRequestSchema)` to create a new message.
 */
export const DeleteAssetsRequestSchema: GenMessage<DeleteAssetsRequest, { jsonType: DeleteAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 10);

/**
 * @generated from message asset.v1.GetAssetRequest
 */
export type GetAssetRequest = Message<"asset.v1.GetAssetRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message asset.v1.GetAssetRequest
 */
export type GetAssetRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message asset.v1.GetAssetRequest.
 * Use `create(GetAssetRequestSchema)` to create a new message.
 */
export const GetAssetRequestSchema: GenMessage<GetAssetRequest, { jsonType: GetAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 11);

/**
 * @generated from message asset.v1.GetAssetsRequest
 */
export type GetAssetsRequest = Message<"asset.v1.GetAssetsRequest"> & {
	/**
	 * @(metabase) Implicitly gets most recent version
	 *
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];

	/**
	 * @generated from field: repeated asset.v1.GetAssetRequest requests = 2;
	 */
	requests: GetAssetRequest[];
};

/**
 * @generated from message asset.v1.GetAssetsRequest
 */
export type GetAssetsRequestJson = {
	/**
	 * @(metabase) Implicitly gets most recent version
	 *
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];

	/**
	 * @generated from field: repeated asset.v1.GetAssetRequest requests = 2;
	 */
	requests?: GetAssetRequestJson[];
};

/**
 * Describes the message asset.v1.GetAssetsRequest.
 * Use `create(GetAssetsRequestSchema)` to create a new message.
 */
export const GetAssetsRequestSchema: GenMessage<GetAssetsRequest, { jsonType: GetAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 12);

/**
 * @generated from message asset.v1.OrgAndWorkspace
 */
export type OrgAndWorkspace = Message<"asset.v1.OrgAndWorkspace"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * @generated from message asset.v1.OrgAndWorkspace
 */
export type OrgAndWorkspaceJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message asset.v1.OrgAndWorkspace.
 * Use `create(OrgAndWorkspaceSchema)` to create a new message.
 */
export const OrgAndWorkspaceSchema: GenMessage<OrgAndWorkspace, { jsonType: OrgAndWorkspaceJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 13);

/**
 * @generated from message asset.v1.ListAssetsRequest
 */
export type ListAssetsRequest = Message<"asset.v1.ListAssetsRequest"> & {
	/**
	 * @generated from oneof asset.v1.ListAssetsRequest.id
	 */
	id:
		| {
				/**
				 * @generated from field: string org_id = 1;
				 */
				value: string;
				case: "orgId";
		  }
		| {
				/**
				 * @generated from field: string workspace_id = 2;
				 */
				value: string;
				case: "workspaceId";
		  }
		| {
				/**
				 * @generated from field: string folder_id = 3;
				 */
				value: string;
				case: "folderId";
		  }
		| {
				/**
				 * @generated from field: asset.v1.OrgAndWorkspace org_and_workspace = 6;
				 */
				value: OrgAndWorkspace;
				case: "orgAndWorkspace";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: asset.v1.AssetFilter filter = 4;
	 */
	filter?: AssetFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message asset.v1.ListAssetsRequest
 */
export type ListAssetsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId?: string;

	/**
	 * @generated from field: asset.v1.OrgAndWorkspace org_and_workspace = 6;
	 */
	orgAndWorkspace?: OrgAndWorkspaceJson;

	/**
	 * @generated from field: asset.v1.AssetFilter filter = 4;
	 */
	filter?: AssetFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message asset.v1.ListAssetsRequest.
 * Use `create(ListAssetsRequestSchema)` to create a new message.
 */
export const ListAssetsRequestSchema: GenMessage<ListAssetsRequest, { jsonType: ListAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 14);

/**
 * @generated from message asset.v1.CountAssetsRequest
 */
export type CountAssetsRequest = Message<"asset.v1.CountAssetsRequest"> & {
	/**
	 * @generated from oneof asset.v1.CountAssetsRequest.id
	 */
	id:
		| {
				/**
				 * @generated from field: string org_id = 1;
				 */
				value: string;
				case: "orgId";
		  }
		| {
				/**
				 * @generated from field: string workspace_id = 2;
				 */
				value: string;
				case: "workspaceId";
		  }
		| {
				/**
				 * @generated from field: string folder_id = 3;
				 */
				value: string;
				case: "folderId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: asset.v1.AssetFilter filter = 4;
	 */
	filter?: AssetFilter | undefined;
};

/**
 * @generated from message asset.v1.CountAssetsRequest
 */
export type CountAssetsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string folder_id = 3;
	 */
	folderId?: string;

	/**
	 * @generated from field: asset.v1.AssetFilter filter = 4;
	 */
	filter?: AssetFilterJson;
};

/**
 * Describes the message asset.v1.CountAssetsRequest.
 * Use `create(CountAssetsRequestSchema)` to create a new message.
 */
export const CountAssetsRequestSchema: GenMessage<CountAssetsRequest, { jsonType: CountAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 15);

/**
 * @generated from message asset.v1.Destination
 */
export type Destination = Message<"asset.v1.Destination"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string path = 3;
	 */
	path: string;
};

/**
 * @generated from message asset.v1.Destination
 */
export type DestinationJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string path = 3;
	 */
	path?: string;
};

/**
 * Describes the message asset.v1.Destination.
 * Use `create(DestinationSchema)` to create a new message.
 */
export const DestinationSchema: GenMessage<Destination, { jsonType: DestinationJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 16);

/**
 * @generated from message asset.v1.MoveAssetsRequest
 */
export type MoveAssetsRequest = Message<"asset.v1.MoveAssetsRequest"> & {
	/**
	 * @generated from field: repeated string asset_ids = 1;
	 */
	assetIds: string[];

	/**
	 * @generated from oneof asset.v1.MoveAssetsRequest.id
	 */
	id:
		| {
				/**
				 * @generated from field: string org_id = 2;
				 */
				value: string;
				case: "orgId";
		  }
		| {
				/**
				 * @generated from field: string workspace_id = 3;
				 */
				value: string;
				case: "workspaceId";
		  }
		| {
				/**
				 * field deprecated in f2
				 *
				 * @generated from field: string folder_id = 4 [deprecated = true];
				 * @deprecated
				 */
				value: string;
				case: "folderId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * used in f2
	 *
	 * @generated from field: asset.v1.Destination destination = 5;
	 */
	destination?: Destination | undefined;
};

/**
 * @generated from message asset.v1.MoveAssetsRequest
 */
export type MoveAssetsRequestJson = {
	/**
	 * @generated from field: repeated string asset_ids = 1;
	 */
	assetIds?: string[];

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * field deprecated in f2
	 *
	 * @generated from field: string folder_id = 4 [deprecated = true];
	 * @deprecated
	 */
	folderId?: string;

	/**
	 * used in f2
	 *
	 * @generated from field: asset.v1.Destination destination = 5;
	 */
	destination?: DestinationJson;
};

/**
 * Describes the message asset.v1.MoveAssetsRequest.
 * Use `create(MoveAssetsRequestSchema)` to create a new message.
 */
export const MoveAssetsRequestSchema: GenMessage<MoveAssetsRequest, { jsonType: MoveAssetsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 17);

/**
 * @generated from message asset.v1.EmptyArchiveRequest
 */
export type EmptyArchiveRequest = Message<"asset.v1.EmptyArchiveRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;
};

/**
 * @generated from message asset.v1.EmptyArchiveRequest
 */
export type EmptyArchiveRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;
};

/**
 * Describes the message asset.v1.EmptyArchiveRequest.
 * Use `create(EmptyArchiveRequestSchema)` to create a new message.
 */
export const EmptyArchiveRequestSchema: GenMessage<EmptyArchiveRequest, { jsonType: EmptyArchiveRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 18);

/**
 * @generated from message asset.v1.UpdateAssetResponse
 */
export type UpdateAssetResponse = Message<"asset.v1.UpdateAssetResponse"> & {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message asset.v1.UpdateAssetResponse
 */
export type UpdateAssetResponseJson = {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message asset.v1.UpdateAssetResponse.
 * Use `create(UpdateAssetResponseSchema)` to create a new message.
 */
export const UpdateAssetResponseSchema: GenMessage<UpdateAssetResponse, { jsonType: UpdateAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 19);

/**
 * @generated from message asset.v1.UpdateAssetsResponse
 */
export type UpdateAssetsResponse = Message<"asset.v1.UpdateAssetsResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets: Asset[];
};

/**
 * @generated from message asset.v1.UpdateAssetsResponse
 */
export type UpdateAssetsResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets?: AssetJson[];
};

/**
 * Describes the message asset.v1.UpdateAssetsResponse.
 * Use `create(UpdateAssetsResponseSchema)` to create a new message.
 */
export const UpdateAssetsResponseSchema: GenMessage<UpdateAssetsResponse, { jsonType: UpdateAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 20);

/**
 * @generated from message asset.v1.ArchiveAssetsResponse
 */
export type ArchiveAssetsResponse = Message<"asset.v1.ArchiveAssetsResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets: Asset[];
};

/**
 * @generated from message asset.v1.ArchiveAssetsResponse
 */
export type ArchiveAssetsResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets?: AssetJson[];
};

/**
 * Describes the message asset.v1.ArchiveAssetsResponse.
 * Use `create(ArchiveAssetsResponseSchema)` to create a new message.
 */
export const ArchiveAssetsResponseSchema: GenMessage<ArchiveAssetsResponse, { jsonType: ArchiveAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 21);

/**
 * @generated from message asset.v1.ArchiveAssetResponse
 */
export type ArchiveAssetResponse = Message<"asset.v1.ArchiveAssetResponse"> & {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message asset.v1.ArchiveAssetResponse
 */
export type ArchiveAssetResponseJson = {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message asset.v1.ArchiveAssetResponse.
 * Use `create(ArchiveAssetResponseSchema)` to create a new message.
 */
export const ArchiveAssetResponseSchema: GenMessage<ArchiveAssetResponse, { jsonType: ArchiveAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 22);

/**
 * @generated from message asset.v1.RestoreAssetResponse
 */
export type RestoreAssetResponse = Message<"asset.v1.RestoreAssetResponse"> & {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message asset.v1.RestoreAssetResponse
 */
export type RestoreAssetResponseJson = {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message asset.v1.RestoreAssetResponse.
 * Use `create(RestoreAssetResponseSchema)` to create a new message.
 */
export const RestoreAssetResponseSchema: GenMessage<RestoreAssetResponse, { jsonType: RestoreAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 23);

/**
 * @generated from message asset.v1.RestoreAssetsResponse
 */
export type RestoreAssetsResponse = Message<"asset.v1.RestoreAssetsResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets: Asset[];
};

/**
 * @generated from message asset.v1.RestoreAssetsResponse
 */
export type RestoreAssetsResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets?: AssetJson[];
};

/**
 * Describes the message asset.v1.RestoreAssetsResponse.
 * Use `create(RestoreAssetsResponseSchema)` to create a new message.
 */
export const RestoreAssetsResponseSchema: GenMessage<RestoreAssetsResponse, { jsonType: RestoreAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 24);

/**
 * @generated from message asset.v1.DeleteAssetResponse
 */
export type DeleteAssetResponse = Message<"asset.v1.DeleteAssetResponse"> & {};

/**
 * @generated from message asset.v1.DeleteAssetResponse
 */
export type DeleteAssetResponseJson = {};

/**
 * Describes the message asset.v1.DeleteAssetResponse.
 * Use `create(DeleteAssetResponseSchema)` to create a new message.
 */
export const DeleteAssetResponseSchema: GenMessage<DeleteAssetResponse, { jsonType: DeleteAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 25);

/**
 * @generated from message asset.v1.DeleteAssetsResponse
 */
export type DeleteAssetsResponse = Message<"asset.v1.DeleteAssetsResponse"> & {};

/**
 * @generated from message asset.v1.DeleteAssetsResponse
 */
export type DeleteAssetsResponseJson = {};

/**
 * Describes the message asset.v1.DeleteAssetsResponse.
 * Use `create(DeleteAssetsResponseSchema)` to create a new message.
 */
export const DeleteAssetsResponseSchema: GenMessage<DeleteAssetsResponse, { jsonType: DeleteAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 26);

/**
 * @generated from message asset.v1.GetAssetResponse
 */
export type GetAssetResponse = Message<"asset.v1.GetAssetResponse"> & {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message asset.v1.GetAssetResponse
 */
export type GetAssetResponseJson = {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message asset.v1.GetAssetResponse.
 * Use `create(GetAssetResponseSchema)` to create a new message.
 */
export const GetAssetResponseSchema: GenMessage<GetAssetResponse, { jsonType: GetAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 27);

/**
 * @generated from message asset.v1.GetAssetsResponse
 */
export type GetAssetsResponse = Message<"asset.v1.GetAssetsResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets: Asset[];
};

/**
 * @generated from message asset.v1.GetAssetsResponse
 */
export type GetAssetsResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets?: AssetJson[];
};

/**
 * Describes the message asset.v1.GetAssetsResponse.
 * Use `create(GetAssetsResponseSchema)` to create a new message.
 */
export const GetAssetsResponseSchema: GenMessage<GetAssetsResponse, { jsonType: GetAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 28);

/**
 * @generated from message asset.v1.ListVersionsRequest
 */
export type ListVersionsRequest = Message<"asset.v1.ListVersionsRequest"> & {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArguments | undefined;

	/**
	 * @generated from field: optional asset.v1.AssetState state = 5;
	 */
	state?: AssetState | undefined;
};

/**
 * @generated from message asset.v1.ListVersionsRequest
 */
export type ListVersionsRequestJson = {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArgumentsJson;

	/**
	 * @generated from field: optional asset.v1.AssetState state = 5;
	 */
	state?: AssetStateJson;
};

/**
 * Describes the message asset.v1.ListVersionsRequest.
 * Use `create(ListVersionsRequestSchema)` to create a new message.
 */
export const ListVersionsRequestSchema: GenMessage<ListVersionsRequest, { jsonType: ListVersionsRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 29);

/**
 * @generated from message asset.v1.ListVersionsResponse
 */
export type ListVersionsResponse = Message<"asset.v1.ListVersionsResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets: Asset[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message asset.v1.ListVersionsResponse
 */
export type ListVersionsResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets?: AssetJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message asset.v1.ListVersionsResponse.
 * Use `create(ListVersionsResponseSchema)` to create a new message.
 */
export const ListVersionsResponseSchema: GenMessage<ListVersionsResponse, { jsonType: ListVersionsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 30);

/**
 * @generated from message asset.v1.CreateVersionRequest
 */
export type CreateVersionRequest = Message<"asset.v1.CreateVersionRequest"> & {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId: string;

	/**
	 * deprecated, use increments
	 *
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment: VersionIncrement;

	/**
	 * if set, specifies version to clone into a new one, otherwise uses most recent version
	 *
	 * @generated from field: string base_version = 3;
	 */
	baseVersion: string;
};

/**
 * @generated from message asset.v1.CreateVersionRequest
 */
export type CreateVersionRequestJson = {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId?: string;

	/**
	 * deprecated, use increments
	 *
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment?: VersionIncrementJson;

	/**
	 * if set, specifies version to clone into a new one, otherwise uses most recent version
	 *
	 * @generated from field: string base_version = 3;
	 */
	baseVersion?: string;
};

/**
 * Describes the message asset.v1.CreateVersionRequest.
 * Use `create(CreateVersionRequestSchema)` to create a new message.
 */
export const CreateVersionRequestSchema: GenMessage<CreateVersionRequest, { jsonType: CreateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 31);

/**
 * @generated from message asset.v1.CreateVersionResponse
 */
export type CreateVersionResponse = Message<"asset.v1.CreateVersionResponse"> & {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message asset.v1.CreateVersionResponse
 */
export type CreateVersionResponseJson = {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message asset.v1.CreateVersionResponse.
 * Use `create(CreateVersionResponseSchema)` to create a new message.
 */
export const CreateVersionResponseSchema: GenMessage<CreateVersionResponse, { jsonType: CreateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 32);

/**
 * @generated from message asset.v1.PublishVersionRequest
 */
export type PublishVersionRequest = Message<"asset.v1.PublishVersionRequest"> & {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: asset.v1.Visibility visibility = 3;
	 */
	visibility: Visibility;
};

/**
 * @generated from message asset.v1.PublishVersionRequest
 */
export type PublishVersionRequestJson = {
	/**
	 * @generated from field: string asset_id = 1;
	 */
	assetId?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: asset.v1.Visibility visibility = 3;
	 */
	visibility?: VisibilityJson;
};

/**
 * Describes the message asset.v1.PublishVersionRequest.
 * Use `create(PublishVersionRequestSchema)` to create a new message.
 */
export const PublishVersionRequestSchema: GenMessage<PublishVersionRequest, { jsonType: PublishVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 33);

/**
 * @generated from message asset.v1.PublishVersionResponse
 */
export type PublishVersionResponse = Message<"asset.v1.PublishVersionResponse"> & {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message asset.v1.PublishVersionResponse
 */
export type PublishVersionResponseJson = {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message asset.v1.PublishVersionResponse.
 * Use `create(PublishVersionResponseSchema)` to create a new message.
 */
export const PublishVersionResponseSchema: GenMessage<PublishVersionResponse, { jsonType: PublishVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 34);

/**
 * @generated from message asset.v1.GetAssetCategoriesRequest
 */
export type GetAssetCategoriesRequest = Message<"asset.v1.GetAssetCategoriesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: asset.v1.AssetFilter filter = 3;
	 */
	filter?: AssetFilter | undefined;
};

/**
 * @generated from message asset.v1.GetAssetCategoriesRequest
 */
export type GetAssetCategoriesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: asset.v1.AssetFilter filter = 3;
	 */
	filter?: AssetFilterJson;
};

/**
 * Describes the message asset.v1.GetAssetCategoriesRequest.
 * Use `create(GetAssetCategoriesRequestSchema)` to create a new message.
 */
export const GetAssetCategoriesRequestSchema: GenMessage<GetAssetCategoriesRequest, { jsonType: GetAssetCategoriesRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 35);

/**
 * @generated from message asset.v1.GetAssetCategoriesResponse
 */
export type GetAssetCategoriesResponse = Message<"asset.v1.GetAssetCategoriesResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Category categories = 1;
	 */
	categories: Category[];
};

/**
 * @generated from message asset.v1.GetAssetCategoriesResponse
 */
export type GetAssetCategoriesResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Category categories = 1;
	 */
	categories?: CategoryJson[];
};

/**
 * Describes the message asset.v1.GetAssetCategoriesResponse.
 * Use `create(GetAssetCategoriesResponseSchema)` to create a new message.
 */
export const GetAssetCategoriesResponseSchema: GenMessage<GetAssetCategoriesResponse, { jsonType: GetAssetCategoriesResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 36);

/**
 * @generated from message asset.v1.Category
 */
export type Category = Message<"asset.v1.Category"> & {
	/**
	 * @generated from field: string category = 1;
	 */
	category: string;

	/**
	 * @generated from field: int64 count = 2;
	 */
	count: bigint;
};

/**
 * @generated from message asset.v1.Category
 */
export type CategoryJson = {
	/**
	 * @generated from field: string category = 1;
	 */
	category?: string;

	/**
	 * @generated from field: int64 count = 2;
	 */
	count?: string;
};

/**
 * Describes the message asset.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema: GenMessage<Category, { jsonType: CategoryJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 37);

/**
 * @generated from message asset.v1.ListAssetsResponse
 */
export type ListAssetsResponse = Message<"asset.v1.ListAssetsResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets: Asset[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message asset.v1.ListAssetsResponse
 */
export type ListAssetsResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets?: AssetJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message asset.v1.ListAssetsResponse.
 * Use `create(ListAssetsResponseSchema)` to create a new message.
 */
export const ListAssetsResponseSchema: GenMessage<ListAssetsResponse, { jsonType: ListAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 38);

/**
 * @generated from message asset.v1.CountAssetsResponse
 */
export type CountAssetsResponse = Message<"asset.v1.CountAssetsResponse"> & {
	/**
	 * @generated from field: int32 num_assets = 1;
	 */
	numAssets: number;
};

/**
 * @generated from message asset.v1.CountAssetsResponse
 */
export type CountAssetsResponseJson = {
	/**
	 * @generated from field: int32 num_assets = 1;
	 */
	numAssets?: number;
};

/**
 * Describes the message asset.v1.CountAssetsResponse.
 * Use `create(CountAssetsResponseSchema)` to create a new message.
 */
export const CountAssetsResponseSchema: GenMessage<CountAssetsResponse, { jsonType: CountAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 39);

/**
 * @generated from message asset.v1.MoveAssetsResponse
 */
export type MoveAssetsResponse = Message<"asset.v1.MoveAssetsResponse"> & {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets: Asset[];
};

/**
 * @generated from message asset.v1.MoveAssetsResponse
 */
export type MoveAssetsResponseJson = {
	/**
	 * @generated from field: repeated asset.v1.Asset assets = 1;
	 */
	assets?: AssetJson[];
};

/**
 * Describes the message asset.v1.MoveAssetsResponse.
 * Use `create(MoveAssetsResponseSchema)` to create a new message.
 */
export const MoveAssetsResponseSchema: GenMessage<MoveAssetsResponse, { jsonType: MoveAssetsResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 40);

/**
 * @generated from message asset.v1.EmptyArchiveResponse
 */
export type EmptyArchiveResponse = Message<"asset.v1.EmptyArchiveResponse"> & {};

/**
 * @generated from message asset.v1.EmptyArchiveResponse
 */
export type EmptyArchiveResponseJson = {};

/**
 * Describes the message asset.v1.EmptyArchiveResponse.
 * Use `create(EmptyArchiveResponseSchema)` to create a new message.
 */
export const EmptyArchiveResponseSchema: GenMessage<EmptyArchiveResponse, { jsonType: EmptyArchiveResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 41);

/**
 * @generated from message asset.v1.GetDefaultAssetRequest
 */
export type GetDefaultAssetRequest = Message<"asset.v1.GetDefaultAssetRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string workspace_id = 2;
	 */
	workspaceId?: string | undefined;

	/**
	 * @generated from field: asset.v1.AssetType asset_type = 3;
	 */
	assetType: AssetType;
};

/**
 * @generated from message asset.v1.GetDefaultAssetRequest
 */
export type GetDefaultAssetRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: asset.v1.AssetType asset_type = 3;
	 */
	assetType?: AssetTypeJson;
};

/**
 * Describes the message asset.v1.GetDefaultAssetRequest.
 * Use `create(GetDefaultAssetRequestSchema)` to create a new message.
 */
export const GetDefaultAssetRequestSchema: GenMessage<GetDefaultAssetRequest, { jsonType: GetDefaultAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 42);

/**
 * @generated from message asset.v1.GetDefaultAssetResponse
 */
export type GetDefaultAssetResponse = Message<"asset.v1.GetDefaultAssetResponse"> & {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: Asset | undefined;
};

/**
 * @generated from message asset.v1.GetDefaultAssetResponse
 */
export type GetDefaultAssetResponseJson = {
	/**
	 * @generated from field: asset.v1.Asset asset = 1;
	 */
	asset?: AssetJson;
};

/**
 * Describes the message asset.v1.GetDefaultAssetResponse.
 * Use `create(GetDefaultAssetResponseSchema)` to create a new message.
 */
export const GetDefaultAssetResponseSchema: GenMessage<GetDefaultAssetResponse, { jsonType: GetDefaultAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 43);

/**
 * @generated from message asset.v1.SetDefaultAssetRequest
 */
export type SetDefaultAssetRequest = Message<"asset.v1.SetDefaultAssetRequest"> & {
	/**
	 * @generated from field: optional string asset_id = 1;
	 */
	assetId?: string | undefined;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string workspace_id = 3;
	 */
	workspaceId?: string | undefined;

	/**
	 * @generated from field: asset.v1.AssetType asset_type = 4;
	 */
	assetType: AssetType;
};

/**
 * @generated from message asset.v1.SetDefaultAssetRequest
 */
export type SetDefaultAssetRequestJson = {
	/**
	 * @generated from field: optional string asset_id = 1;
	 */
	assetId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: asset.v1.AssetType asset_type = 4;
	 */
	assetType?: AssetTypeJson;
};

/**
 * Describes the message asset.v1.SetDefaultAssetRequest.
 * Use `create(SetDefaultAssetRequestSchema)` to create a new message.
 */
export const SetDefaultAssetRequestSchema: GenMessage<SetDefaultAssetRequest, { jsonType: SetDefaultAssetRequestJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 44);

/**
 * @generated from message asset.v1.SetDefaultAssetResponse
 */
export type SetDefaultAssetResponse = Message<"asset.v1.SetDefaultAssetResponse"> & {};

/**
 * @generated from message asset.v1.SetDefaultAssetResponse
 */
export type SetDefaultAssetResponseJson = {};

/**
 * Describes the message asset.v1.SetDefaultAssetResponse.
 * Use `create(SetDefaultAssetResponseSchema)` to create a new message.
 */
export const SetDefaultAssetResponseSchema: GenMessage<SetDefaultAssetResponse, { jsonType: SetDefaultAssetResponseJson }> = /*@__PURE__*/ messageDesc(file_asset_v1_asset, 45);

/**
 * @generated from enum asset.v1.AssetState
 */
export enum AssetState {
	/**
	 * @generated from enum value: ASSET_STATE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ASSET_STATE_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * @generated from enum value: ASSET_STATE_DRAFT = 2;
	 */
	DRAFT = 2,

	/**
	 * @generated from enum value: ASSET_STATE_ARCHIVED = 3;
	 */
	ARCHIVED = 3,
}

/**
 * @generated from enum asset.v1.AssetState
 */
export type AssetStateJson = "ASSET_STATE_UNSPECIFIED" | "ASSET_STATE_ACTIVE" | "ASSET_STATE_DRAFT" | "ASSET_STATE_ARCHIVED";

/**
 * Describes the enum asset.v1.AssetState.
 */
export const AssetStateSchema: GenEnum<AssetState, AssetStateJson> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 0);

/**
 * @generated from enum asset.v1.AssetType
 */
export enum AssetType {
	/**
	 * @generated from enum value: ASSET_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ASSET_TYPE_CODE = 1;
	 */
	CODE = 1,

	/**
	 * @generated from enum value: ASSET_TYPE_PAGE = 2;
	 */
	PAGE = 2,

	/**
	 * @generated from enum value: ASSET_TYPE_PAGE_V2 = 3;
	 */
	PAGE_V2 = 3,

	/**
	 * @generated from enum value: ASSET_TYPE_PAGE_TEMPLATE_V2 = 4;
	 */
	PAGE_TEMPLATE_V2 = 4,

	/**
	 * @generated from enum value: ASSET_TYPE_BUNDLE = 5;
	 */
	BUNDLE = 5,

	/**
	 * @generated from enum value: ASSET_TYPE_SUITE = 6;
	 */
	SUITE = 6,

	/**
	 * @generated from enum value: ASSET_TYPE_BRAND_KIT = 7;
	 */
	BRAND_KIT = 7,

	/**
	 * @generated from enum value: ASSET_TYPE_STUDIO_CONFIG = 8;
	 */
	STUDIO_CONFIG = 8,

	/**
	 * @generated from enum value: ASSET_TYPE_CODE_V3 = 9;
	 */
	CODE_V3 = 9,

	/**
	 * @generated from enum value: ASSET_TYPE_BATCH = 10;
	 */
	BATCH = 10,

	/**
	 * @generated from enum value: ASSET_TYPE_BATCH_TEMPLATE = 11;
	 */
	BATCH_TEMPLATE = 11,

	/**
	 * @generated from enum value: ASSET_TYPE_WALLET_PASS_BATCH = 12;
	 */
	WALLET_PASS_BATCH = 12,

	/**
	 * @generated from enum value: ASSET_TYPE_WALLET_PASS_TEMPLATE = 13;
	 */
	WALLET_PASS_TEMPLATE = 13,

	/**
	 * @generated from enum value: ASSET_TYPE_WALLET_PASS = 14;
	 */
	WALLET_PASS = 14,

	/**
	 * @generated from enum value: ASSET_TYPE_SHORT_URL = 15;
	 */
	SHORT_URL = 15,

	/**
	 * @generated from enum value: ASSET_TYPE_MODULE_TEMPLATE = 17;
	 */
	MODULE_TEMPLATE = 17,

	/**
	 * @generated from enum value: ASSET_TYPE_MODULE = 18;
	 */
	MODULE = 18,

	/**
	 * @generated from enum value: ASSET_TYPE_ENTRYPOINT_BATCH = 19;
	 */
	ENTRYPOINT_BATCH = 19,

	/**
	 * @generated from enum value: ASSET_TYPE_ENTRYPOINT_BATCH_TEMPLATE = 20;
	 */
	ENTRYPOINT_BATCH_TEMPLATE = 20,

	/**
	 * @generated from enum value: ASSET_TYPE_CONTACT_SCHEMA = 21 [deprecated = true];
	 * @deprecated
	 */
	CONTACT_SCHEMA = 21,

	/**
	 * @generated from enum value: ASSET_TYPE_STATIC_ASSET = 22;
	 */
	STATIC_ASSET = 22,

	/**
	 * @generated from enum value: ASSET_TYPE_FORM = 23;
	 */
	FORM = 23,

	/**
	 * @generated from enum value: ASSET_TYPE_TERMS_AND_CONDITIONS = 24;
	 */
	TERMS_AND_CONDITIONS = 24,

	/**
	 * @generated from enum value: ASSET_TYPE_POLL = 25;
	 */
	POLL = 25,
}

/**
 * @generated from enum asset.v1.AssetType
 */
export type AssetTypeJson =
	| "ASSET_TYPE_UNSPECIFIED"
	| "ASSET_TYPE_CODE"
	| "ASSET_TYPE_PAGE"
	| "ASSET_TYPE_PAGE_V2"
	| "ASSET_TYPE_PAGE_TEMPLATE_V2"
	| "ASSET_TYPE_BUNDLE"
	| "ASSET_TYPE_SUITE"
	| "ASSET_TYPE_BRAND_KIT"
	| "ASSET_TYPE_STUDIO_CONFIG"
	| "ASSET_TYPE_CODE_V3"
	| "ASSET_TYPE_BATCH"
	| "ASSET_TYPE_BATCH_TEMPLATE"
	| "ASSET_TYPE_WALLET_PASS_BATCH"
	| "ASSET_TYPE_WALLET_PASS_TEMPLATE"
	| "ASSET_TYPE_WALLET_PASS"
	| "ASSET_TYPE_SHORT_URL"
	| "ASSET_TYPE_MODULE_TEMPLATE"
	| "ASSET_TYPE_MODULE"
	| "ASSET_TYPE_ENTRYPOINT_BATCH"
	| "ASSET_TYPE_ENTRYPOINT_BATCH_TEMPLATE"
	| "ASSET_TYPE_CONTACT_SCHEMA"
	| "ASSET_TYPE_STATIC_ASSET"
	| "ASSET_TYPE_FORM"
	| "ASSET_TYPE_TERMS_AND_CONDITIONS"
	| "ASSET_TYPE_POLL";

/**
 * Describes the enum asset.v1.AssetType.
 */
export const AssetTypeSchema: GenEnum<AssetType, AssetTypeJson> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 1);

/**
 * @generated from enum asset.v1.CreationMethod
 */
export enum CreationMethod {
	/**
	 * @generated from enum value: CREATION_METHOD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CREATION_METHOD_PLATFORM = 1;
	 */
	PLATFORM = 1,

	/**
	 * @generated from enum value: CREATION_METHOD_API = 2;
	 */
	API = 2,
}

/**
 * @generated from enum asset.v1.CreationMethod
 */
export type CreationMethodJson = "CREATION_METHOD_UNSPECIFIED" | "CREATION_METHOD_PLATFORM" | "CREATION_METHOD_API";

/**
 * Describes the enum asset.v1.CreationMethod.
 */
export const CreationMethodSchema: GenEnum<CreationMethod, CreationMethodJson> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 2);

/**
 * @generated from enum asset.v1.ArchiveReason
 */
export enum ArchiveReason {
	/**
	 * @generated from enum value: ARCHIVE_REASON_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ARCHIVE_REASON_USER_ARCHIVAL = 1;
	 */
	USER_ARCHIVAL = 1,

	/**
	 * @generated from enum value: ARCHIVE_REASON_SUBSCRIPTION_CANCELLED = 2;
	 */
	SUBSCRIPTION_CANCELLED = 2,

	/**
	 * @generated from enum value: ARCHIVE_REASON_CONTENT_MODERATION = 3;
	 */
	CONTENT_MODERATION = 3,

	/**
	 * @generated from enum value: ARCHIVE_REASON_ML_MODERATION = 4;
	 */
	ML_MODERATION = 4,

	/**
	 * @generated from enum value: ARCHIVE_REASON_FOLDER_ARCHIVED = 5;
	 */
	FOLDER_ARCHIVED = 5,

	/**
	 * @generated from enum value: ARCHIVE_REASON_PARENT_ARCHIVED = 6;
	 */
	PARENT_ARCHIVED = 6,
}

/**
 * @generated from enum asset.v1.ArchiveReason
 */
export type ArchiveReasonJson = "ARCHIVE_REASON_UNSPECIFIED" | "ARCHIVE_REASON_USER_ARCHIVAL" | "ARCHIVE_REASON_SUBSCRIPTION_CANCELLED" | "ARCHIVE_REASON_CONTENT_MODERATION" | "ARCHIVE_REASON_ML_MODERATION" | "ARCHIVE_REASON_FOLDER_ARCHIVED" | "ARCHIVE_REASON_PARENT_ARCHIVED";

/**
 * Describes the enum asset.v1.ArchiveReason.
 */
export const ArchiveReasonSchema: GenEnum<ArchiveReason, ArchiveReasonJson> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 3);

/**
 * @generated from enum asset.v1.Visibility
 */
export enum Visibility {
	/**
	 * @generated from enum value: VISIBILITY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: VISIBILITY_PRIVATE = 1;
	 */
	PRIVATE = 1,

	/**
	 * @generated from enum value: VISIBILITY_PUBLIC = 2;
	 */
	PUBLIC = 2,

	/**
	 * @generated from enum value: VISIBILITY_ORG = 3;
	 */
	ORG = 3,

	/**
	 * @generated from enum value: VISIBILITY_INTERNAL = 4;
	 */
	INTERNAL = 4,
}

/**
 * @generated from enum asset.v1.Visibility
 */
export type VisibilityJson = "VISIBILITY_UNSPECIFIED" | "VISIBILITY_PRIVATE" | "VISIBILITY_PUBLIC" | "VISIBILITY_ORG" | "VISIBILITY_INTERNAL";

/**
 * Describes the enum asset.v1.Visibility.
 */
export const VisibilitySchema: GenEnum<Visibility, VisibilityJson> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 4);

/**
 * @generated from enum asset.v1.Location
 */
export enum Location {
	/**
	 * @generated from enum value: LOCATION_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: LOCATION_ROOT = 1;
	 */
	ROOT = 1,

	/**
	 * @generated from enum value: LOCATION_FOLDER = 2;
	 */
	FOLDER = 2,
}

/**
 * @generated from enum asset.v1.Location
 */
export type LocationJson = "LOCATION_UNSPECIFIED" | "LOCATION_ROOT" | "LOCATION_FOLDER";

/**
 * Describes the enum asset.v1.Location.
 */
export const LocationSchema: GenEnum<Location, LocationJson> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 5);

/**
 * @generated from enum asset.v1.VersionIncrement
 */
export enum VersionIncrement {
	/**
	 * @generated from enum value: VERSION_INCREMENT_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: VERSION_INCREMENT_MAJOR = 1;
	 */
	MAJOR = 1,

	/**
	 * @generated from enum value: VERSION_INCREMENT_MINOR = 2;
	 */
	MINOR = 2,

	/**
	 * @generated from enum value: VERSION_INCREMENT_PATCH = 3;
	 */
	PATCH = 3,
}

/**
 * @generated from enum asset.v1.VersionIncrement
 */
export type VersionIncrementJson = "VERSION_INCREMENT_UNSPECIFIED" | "VERSION_INCREMENT_MAJOR" | "VERSION_INCREMENT_MINOR" | "VERSION_INCREMENT_PATCH";

/**
 * Describes the enum asset.v1.VersionIncrement.
 */
export const VersionIncrementSchema: GenEnum<VersionIncrement, VersionIncrementJson> = /*@__PURE__*/ enumDesc(file_asset_v1_asset, 6);

/**
 * @generated from service asset.v1.AssetService
 */
export const AssetService: GenService<{
	/**
	 * Defaults
	 *
	 * @generated from rpc asset.v1.AssetService.GetDefaultAsset
	 */
	getDefaultAsset: {
		methodKind: "unary";
		input: typeof GetDefaultAssetRequestSchema;
		output: typeof GetDefaultAssetResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.SetDefaultAsset
	 */
	setDefaultAsset: {
		methodKind: "unary";
		input: typeof SetDefaultAssetRequestSchema;
		output: typeof SetDefaultAssetResponseSchema;
	};
	/**
	 * Mutations
	 *
	 * @generated from rpc asset.v1.AssetService.UpdateAsset
	 */
	updateAsset: {
		methodKind: "unary";
		input: typeof UpdateAssetRequestSchema;
		output: typeof UpdateAssetResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.UpdateAssets
	 */
	updateAssets: {
		methodKind: "unary";
		input: typeof UpdateAssetsRequestSchema;
		output: typeof UpdateAssetsResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.ArchiveAsset
	 */
	archiveAsset: {
		methodKind: "unary";
		input: typeof ArchiveAssetRequestSchema;
		output: typeof ArchiveAssetResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.ArchiveAssets
	 */
	archiveAssets: {
		methodKind: "unary";
		input: typeof ArchiveAssetsRequestSchema;
		output: typeof ArchiveAssetsResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.RestoreAsset
	 */
	restoreAsset: {
		methodKind: "unary";
		input: typeof RestoreAssetRequestSchema;
		output: typeof RestoreAssetResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.RestoreAssets
	 */
	restoreAssets: {
		methodKind: "unary";
		input: typeof RestoreAssetsRequestSchema;
		output: typeof RestoreAssetsResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.DeleteAsset
	 */
	deleteAsset: {
		methodKind: "unary";
		input: typeof DeleteAssetRequestSchema;
		output: typeof DeleteAssetResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.DeleteAssets
	 */
	deleteAssets: {
		methodKind: "unary";
		input: typeof DeleteAssetsRequestSchema;
		output: typeof DeleteAssetsResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.MoveAssets
	 */
	moveAssets: {
		methodKind: "unary";
		input: typeof MoveAssetsRequestSchema;
		output: typeof MoveAssetsResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.EmptyArchive
	 */
	emptyArchive: {
		methodKind: "unary";
		input: typeof EmptyArchiveRequestSchema;
		output: typeof EmptyArchiveResponseSchema;
	};
	/**
	 * Queries
	 *
	 * @generated from rpc asset.v1.AssetService.GetAsset
	 */
	getAsset: {
		methodKind: "unary";
		input: typeof GetAssetRequestSchema;
		output: typeof GetAssetResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.GetAssets
	 */
	getAssets: {
		methodKind: "unary";
		input: typeof GetAssetsRequestSchema;
		output: typeof GetAssetsResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.GetAssetCategories
	 */
	getAssetCategories: {
		methodKind: "unary";
		input: typeof GetAssetCategoriesRequestSchema;
		output: typeof GetAssetCategoriesResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.ListAssets
	 */
	listAssets: {
		methodKind: "unary";
		input: typeof ListAssetsRequestSchema;
		output: typeof ListAssetsResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.CountAssets
	 */
	countAssets: {
		methodKind: "unary";
		input: typeof CountAssetsRequestSchema;
		output: typeof CountAssetsResponseSchema;
	};
	/**
	 * Versions
	 *
	 * @generated from rpc asset.v1.AssetService.CreateVersion
	 */
	createVersion: {
		methodKind: "unary";
		input: typeof CreateVersionRequestSchema;
		output: typeof CreateVersionResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.PublishVersion
	 */
	publishVersion: {
		methodKind: "unary";
		input: typeof PublishVersionRequestSchema;
		output: typeof PublishVersionResponseSchema;
	};
	/**
	 * @generated from rpc asset.v1.AssetService.ListVersions
	 */
	listVersions: {
		methodKind: "unary";
		input: typeof ListVersionsRequestSchema;
		output: typeof ListVersionsResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_asset_v1_asset, 0);
